import type React from "react";
import type { PropsWithChildren } from "react";

export const VaultContractProvider: React.FC<PropsWithChildren> = ({ children }) => {
  // Vault contract check is now done in Providers.tsx before STORE creation
  return <>{children}</>;
};
